<template>
   <component
        :is="tag"
        :href="tag === 'a' ? to : undefined"
        :type="tag === 'button' ? type : undefined"
        class="btn"
        :class="[`btn-${size}`, `btn-${variant}`, customClass]"
        :disabled="isDisabled"
        :aria-disabled="isDisabled"
    >
        <i
            v-if="icon && !loading"
            class="bi pe-1"
            :class="icon"
            aria-hidden="true"
        ></i>
        
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status"></span>

        <slot />
    </component>
</template>
<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        size?: "sm" | "md" | "lg";
        variant?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark";
        icon?: string;
        type?: "button" | "submit" | "reset";
        disabled?: boolean;
        loading?: boolean;
        to?: string | undefined | null;
        class?: string | null;
        ariaLabel?: string;
    }>(),
    {
        size: "md",
        variant: "primary",
        type: "button",
        loading: false,
        disabled: false,
    }
);

// Provide aria-label when icon-only and no explicit label provided
const iconOnlyLabel = computed(() => {
    if (props.ariaLabel) return props.ariaLabel;
    return undefined;
});
const tag = computed(() => (props.to ? 'a' : 'button'));
const isDisabled = computed(() => props.disabled || props.loading);
const customClass = computed(() => props.class);
</script>
